import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { modulemedia } from 'src/app/models/module/moduledetails';
import * as hdate from 'human-date';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';

@Component({
  selector: 'app-media-library-media',
  templateUrl: './media-library-media.component.html',
  styleUrls: ['./media-library-media.component.css']
})
export class ModuleMediaLibraryMediaComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() media: modulemedia = new modulemedia();
  @Input() enableselect: boolean;
  @Output() deleteConfirmed: EventEmitter<modulemedia> = new EventEmitter<modulemedia>();
  @Output() mediaSelected: EventEmitter<modulemedia> = new EventEmitter<modulemedia>();
  refreshinterval;

  deleteMode: boolean = false;

  constructor(private modulemanager: ModulemanagementService) { 

  }

  ngAfterViewInit(): void {
    if(!this.media.processed && !this.media.errorprocessing)
    {
      this.refreshinterval = setInterval(async () => {
        const retreivedmedia: modulemedia = await this.modulemanager.getSingleMedia(this.media.moduleid, this.media.uploadid).toPromise();
        if(retreivedmedia.processed || retreivedmedia.errorprocessing){
          clearInterval(this.refreshinterval);
          this.media = retreivedmedia;
        }
      }, 10000);
    }
  }
  ngOnDestroy(): void {
    //throw new Error('Method not implemented.');
    if(this.refreshinterval){
      clearInterval(this.refreshinterval);
    }
  }

  ngOnInit(): void {
    //console.log(`enableselect = ${this.enableselect}`);
    //debugger;
  }

  formattedDate(date: Date):string{
    //debugger;
    return hdate.prettyPrint(date, {showTime: true});
  }
  formattedSize(size: number):string{
      //debugger;
      return this.humanFileSize(size, true);
  }
  humanFileSize(bytes, si=false, dp=1) {
    const thresh = si ? 1000 : 1024;
  
    if (Math.abs(bytes) < thresh) {
      return bytes + ' B';
    }
  
    const units = si 
      ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] 
      : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
    let u = -1;
    const r = 10**dp;
  
    do {
      bytes /= thresh;
      ++u;
    } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);
  
  
    return bytes.toFixed(dp) + ' ' + units[u];
  }

  deleteClicked(){
    this.deleteMode = true;
  }

  confirmDeleteClicked(){
    this.deleteConfirmed.emit(this.media);
  }

  cancelDeleteClicked(){
    this.deleteMode = false;
  }

  selectClicked(){
    this.mediaSelected.emit(this.media);
  }

  async retryMediaProcessing(){
    if(this.media.errorprocessing && !this.media.processed)
      await this.modulemanager.retryMediaProcessing(this.media.moduleid, this.media.uploadid).toPromise();
    location.reload();
  }
}
